import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import { OverflowMenuItem, OverflowMenu } from 'carbon-components-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { IlIconInitializer } from '../../IlIconInitializer/index.js';
import { IlIcon } from '../../IlIcon/index.js';

var IlOverflowMenu = /*#__PURE__*/function (_Component) {
  function IlOverflowMenu(props) {
    var _this;
    _classCallCheck(this, IlOverflowMenu);
    _this = _callSuper(this, IlOverflowMenu, [props]);
    /**
     * implements two accessibility fixes on the menu container
     * it would be nice to provide this functionality in "the React way"
     * but it's simply not possible given the opaque and rigid underlying Carbon architecture
     */
    _defineProperty(_this, "clickHandler", function (e) {
      // wait for the menu to expand and focus
      setTimeout(function () {
        if (_this.button.current && _this.button.current.getAttribute('aria-expanded') === 'true') {
          // fix our roles for selection each time the menu is expanded
          var menuNode = document.activeElement.parentElement.parentElement;
          _this.fixSelectionAttributes(menuNode);
          // only add the listener to fix the tab sequence once
          // and no need to fix tab sequence within a shadow root
          if (!menuNode.dataset.tabSequenceFixed && !document.activeElement.shadowRoot) {
            _this.fixTabSequence(menuNode);
          }
        } else {
          // Carbon also neglects to focus the button on toggling the menu closed
          // so, if we just did, focus it
          _this.button.current && _this.button.current.focus();
        }
      });
    });
    /**
     * opens the menu on down arrow key press
     * if Carbon ever adds this W3 requirement
     * this method should be removed
     * @param {Object} e React synthetic keydown event
     */
    _defineProperty(_this, "openOnDownArrowPress", function (e) {
      var button = _this.button.current;
      var expanded = button.getAttribute('aria-expanded') === 'true';
      var pressingArrowDown = e.key === 'ArrowDown' /* Real Browsers */ || e.key === 'Down' /* IE11 */;
      if (!expanded && pressingArrowDown) {
        button.click();
      }
    });
    _this.button = /*#__PURE__*/React__default.createRef();
    return _this;
  }

  /**
   * prerenders any wrappers to Carbon OverflowMenuItem class instances
   * because the Carbon OverflowMenu class only accepts children of that class
   * @returns {Array} the children collection
   */
  _inherits(IlOverflowMenu, _Component);
  return _createClass(IlOverflowMenu, [{
    key: "prerenderChildren",
    value: function prerenderChildren(childrenArg) {
      // defend against null children property
      // and other react testing library scenarios
      if (!(childrenArg && childrenArg.map && childrenArg.flat)) {
        return childrenArg;
      }

      // flatten any nested arrays of children provided in combination with jsx
      var children = childrenArg.flat(1).map(function (childArg) {
        var child = childArg;
        var childInstance;
        // recursively drill down until we either reach the Carbon OverflowMenuItem instance
        // or reach a native HTML tag
        while (child.type.name && child.type.name !== OverflowMenuItem.name) {
          /* eslint-disable new-cap */
          childInstance = new child.type();
          childInstance.props = child.props;
          child = childInstance.render();
        }
        return child;
      });
      return children;
    }
  }, {
    key: "fixSelectionAttributes",
    value:
    /**
     * enables item selection in a way that screen readers can detect
     * @param {HTMLElement} menuNode
     */
    function fixSelectionAttributes(menuNode) {
      var menuItemNodes = menuNode.children;
      Array.from(menuItemNodes).forEach(function (item) {
        // Carbon gives us no access to these menu items
        // and the Carbon supplied menuitem role does not allow us to use aria-checked
        // so switch our role to menuitemcheckbox
        // see https://www.w3.org/TR/wai-aria-1.2/#menuitemcheckbox for details
        item.setAttribute('role', 'none');
        item.firstElementChild.setAttribute('role', 'menuitemcheckbox');
        // ideally developers should pass the aria-checked attribute to the selected ilOverflowMenuItem component
        // but just in case someone only uses a CSS class containing the word check
        // set the proper attribute
        if (item.firstElementChild.className.indexOf('check') >= 0) {
          item.setAttribute('aria-checked', 'true');
        }
      });
    }

    /**
     * corrects aberrant behaviors when tabbing off the Carbon overflow menu component
     * @param {HTMLElement} button the menu button triggering opening of our menu
     */
  }, {
    key: "fixTabSequence",
    value: function fixTabSequence(menuNode) {
      var focusableSelector = "a[href],\n      button:not([disabled]):not([tabindex=\"-1\"]),\n      input:not([type=radio]):not([type=file]):not([disabled]),\n      select,\n      textarea,\n      [tabindex=\"0\"]";
      var button = this.button.current;
      var focusableControls;
      var nextFocusableControl;
      menuNode.addEventListener('keydown', function (e) {
        // wait for Carbon to screw up the focus
        setTimeout(function () {
          if (e.key === 'Tab') {
            if (e.shiftKey) {
              // shift+tab should go to the button
              // so we that follow our usual tab sequence
              // as if the menu were in the DOM directly after our button
              // though it could be anywhere
              button.focus();
            } else {
              // tab should go to the next focusable control after the button
              // again so we that follow our usual tab sequence
              // as if the menu were in the DOM directly after our button
              focusableControls = _toConsumableArray(document.body.querySelectorAll(focusableSelector));
              nextFocusableControl = focusableControls[focusableControls.indexOf(button) + 1];
              if (nextFocusableControl) {
                nextFocusableControl.focus();
              } else {
                button.focus();
              }
            }
            // close the menu
            document.body.click();
          }
        });
      });
    }
  }, {
    key: "defaulIcon",
    value: function defaulIcon() {
      return /*#__PURE__*/React__default.createElement(IlIcon, {
        name: "gs-more2",
        size: 16
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.prerenderChildren(this.props.children);
      var className = this.props.className;
      var props = _objectSpread2(_objectSpread2({}, this.props), {}, {
        children: children
      });
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IlIconInitializer, null), /*#__PURE__*/React__default.createElement(OverflowMenu, _extends({}, props, {
        renderIcon: props.renderIcon ? props.renderIcon : this.defaulIcon,
        flipped: props.flipped,
        className: classNames(className, {
          'iloverflowmenu--size--small': props.small
        }, {
          'iloverflowmenu--disabled': props.disabled
        }),
        onClick: this.clickHandler,
        onKeyUp: this.openOnDownArrowPress,
        ref: this.button,
        disabled: props.disabled
      })));
    }
  }]);
}(Component);
_defineProperty(IlOverflowMenu, "defaultProps", {
  flipped: true,
  small: false
});
IlOverflowMenu.propTypes = {
  children: PropTypes.node.isRequired,
  small: PropTypes.bool,
  flipped: PropTypes.bool,
  disabled: PropTypes.bool
};

export { IlOverflowMenu };
